<template>
  <card title="Settings">
    <label>Type</label>
    <el-select v-model="form.type" class="mb-3" style="width:100%">
      <el-option label="Procedure" value="procedure" />
      <el-option label="Illness" value="illness" />
    </el-select>

    <label>Level</label>
    <el-select v-model="form.level" class="mb-3" style="width:100%">
      <el-option
        v-for="lv in levelOptions"
        :key="lv"
        :label="`Level ${lv}`"
        :value="lv"
      />
    </el-select>

    <label>Score</label>
    <base-input v-model.number="form.score" placeholder="Score" type="number" class="mb-2" />

    <label>Template ID</label>
    <base-input v-model="form.template_id" placeholder="Template ID" class="mb-2" />

    <label>Tags (comma separated)</label>
    <base-input
      :value="tagsInput"
      placeholder="e.g. promo, top"
      class="mb-3"
      @input="$emit('update:tagsInput', $event)"
    />

    <label>Package price</label>
    <base-input
      v-model.number="form.packagePrice"
      type="number"
      min="0"
      placeholder="Package price"
      class="mb-3"
    />

    <label>Currency</label>
    <el-select
      v-model="form.currency_code"
      filterable
      clearable
      placeholder="Currency"
      no-data-text="No data"
      no-match-text="No match"
      class="mb-3"
      style="width: 100%"
    >
      <el-option
        v-for="c in currencies"
        :key="c.code"
        :label="c.code"
        :value="c.code"
      />
    </el-select>

    <el-checkbox v-model="form.is_hide" class="d-block">Is hide</el-checkbox>
  </card>
</template>

<script>
export default {
  name: "OfferFormSettingsCard",
  props: {
    form: { type: Object, required: true },
    tagsInput: { type: String, default: "" },
    currencies: { type: Array, required: true },
    levelOptions: { type: Array, required: true }
  }
};
</script>
